module.exports = __webpack_public_path__ + "media/images/favicon/primary/favicon-32x32-cd5f61f2f3a6ef0b9bbca137f4a5271f.png";